module.exports = __webpack_public_path__ + "img/s_1.8b932175.png";